/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    object,
} from 'prop-types';

const styles = (theme) => ({
    container: {
        width: '100%',
        margin: '10px auto 60px auto',
        '& table': {
            fontSize: '14px',
            margin: '20px 2%',
            width: '45%',
            verticalAlign: 'top',
            display: 'inline-block',
            '& thead': {
                fontWeight: 'bold',
            },
            '& tbody': {
                '& tr td:nth-child(even)': {
                    textAlign: 'right',
                },
                '& td': {
                    borderBottom: `1px solid ${theme.palette.black}`,
                },
            },
        },

        '& h1, h2': {
            textAlign: 'center',
            lineHeight: '30px',
            fontSize: '24px',
        },
        '& h3': {
            fontSize: '18px',
        },
    },

});

const ShippingInfo = ({ classes }) => (
    <div id="shippingDialog" className={classes.container}>
        <h3>Shipping &amp; Processing</h3>
        <p>
            Standard Shipping charges are intended to cover the costs incurred to process, prepare, and transport your order and
            related customer service. Standard rates are based on the non-sale price, as detailed in the charts&nbsp;below.
        </p>
        <p>
            Please Note: Shipping &amp; Processing is calculated using the regular price of merchandise before tax is applied.
            An exhaustive list of shipping charges and information can be found on our Shipping &amp; Processing page.
        </p>
        <div id="leftShipCol">
            <table id="stdShipTable" cellPadding="0" cellSpacing="0" border="0">
                <thead>
                    <tr>
                        <th colSpan="2" className="shipTableHead">Standard Shipping and Processing&nbsp;Rates*</th>
                    </tr>
                    <tr>
                        <th>Order Subtotal Per Shipping Address to a Named Recipient</th>
                        <th>Add</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>$0.01 - $15.00</td>
                        <td>$6.99</td>
                    </tr>
                    <tr>
                        <td>$15.01 - $25.00</td>
                        <td>$8.99</td>
                    </tr>
                    <tr>
                        <td>$25.01 - $35.00</td>
                        <td>$11.99</td>
                    </tr>
                    <tr>
                        <td>$35.01 - $45.00</td>
                        <td>$12.99</td>
                    </tr>
                    <tr>
                        <td>$45.01 - $60.00</td>
                        <td>$14.99</td>
                    </tr>
                    <tr>
                        <td>$60.01 - $75.00</td>
                        <td>$16.99</td>
                    </tr>
                    <tr>
                        <td>$75.01 - $100.00</td>
                        <td>$18.99</td>
                    </tr>
                    <tr>
                        <td>$100.01 - $125.00</td>
                        <td>$20.99</td>
                    </tr>
                    <tr>
                        <td>$125.01 - $150.00</td>
                        <td>$22.99</td>
                    </tr>
                    <tr>
                        <td>$150.01 and over</td>
                        <td>15% of order subtotal</td>
                    </tr>
                    <tr>
                        <td>P.O. Box surcharge</td>
                        <td>$5.99</td>
                    </tr>
                </tbody>
            </table>

            <table id="expShipTable" cellPadding="0" cellSpacing="0" border="0">
                <thead>
                    <tr>
                        <th colSpan="2" className="shipTableHead">Express Shipping and Processing&nbsp;Rates</th>
                    </tr>
                    <tr>
                        <th>Express Method</th>
                        <th>Charge Per Item</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>3-Day Express (3&nbsp;business&nbsp;days)†</td>
                        <td>$9.99 per item + Standard&nbsp;Rate</td>
                    </tr>
                    <tr>
                        <td>2-Day Express (2&nbsp;business&nbsp;days)†</td>
                        <td>$11.99 per item + Standard&nbsp;Rate</td>
                    </tr>
                    <tr>
                        <td>Overnight Express†</td>
                        <td>$19.99 per item + Standard&nbsp;Rate</td>
                    </tr>
                    <tr>
                        <td>Priority Overnight (where&nbsp;available)†‡</td>
                        <td>$24.99 per item + Standard&nbsp;Rate</td>
                    </tr>
                </tbody>
            </table>

            <table id="shipKeyTable" cellPadding="0" cellSpacing="0" border="0">
                <tbody>
                    <tr>
                        <td>*</td>
                        <td>Standard shipping and processing charges are based on the regular price of
                            merchandise shipped to a named recipient at a single&nbsp;address.
                        </td>
                    </tr>
                    <tr>
                        <td>†</td>
                        <td>Orders must be placed by 1 p.m. ET.</td>
                    </tr>
                    <tr>
                        <td>‡</td>
                        <td>Saturday arrival to some locations.</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div id="rightShipCol">
            <table id="clubShipTable" cellPadding="0" cellSpacing="0" border="0">
                <thead>
                    <tr>
                        <th colSpan="2" className="shipTableHead">Club Shipping and Processing&nbsp;Rates</th>
                    </tr>
                    <tr>
                        <th>Club</th>
                        <th>Add</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{'Cheryl\'s Cookie&nbsp;Clubs'}</td>
                        <td>Shipping included</td>
                    </tr>
                    <tr>
                        <td>Great Foods Gourmet Clubs,<br />Signature Light Clubs,<br />Canada Light Clubs, <br />Moose Munch® Clubs, <br />{'Mother\'s'} Day Clubs, <br />{'Father\'s'} Day Clubs, <br />Quarterly Gift Club, <br />Vegetable Clubs</td>
                        <td>$5.99 per shipment</td>
                    </tr>

                    <tr>
                        <td>
                            Signature Classic Clubs, Canada Classic Clubs, Medley Clubs, Presidential Clubs, Organic Clubs, Favorites Clubs, Citrus Clubs, Fruit and Cheese Clubs, Chocolate Clubs, Dessert Clubs, Plant<br /> and Bulb&nbsp; Clubs, The Favorite Pear Clubs
                        </td>
                        <td>$6.99 per shipment</td>
                    </tr>

                    <tr>
                        <td>Fruit, Wine, and Cheese Clubs, Wine Clubs, Wine and Cheese Clubs, Cheesecake Factory Clubs, Dipped
                            Fruit&nbsp;Clubs
                        </td>
                        <td>$9.99 per shipment</td>
                    </tr>
                    <tr>
                        <td>Wine add-ons</td>
                        <td>$5.99 per bottle</td>
                    </tr>
                </tbody>
            </table>

            <table id="intShipTable" cellPadding="0" cellSpacing="0" border="0">
                <thead>
                    <tr>
                        <th colSpan="2" className="shipTableHead">International Orders/APO/FPO</th>
                    </tr>
                    <tr>
                        <th>Express Method</th>
                        <th>Charge Per Item</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Alaska &amp; Hawaii<br />(5&nbsp;business&nbsp;days)</td>
                        <td>$9.99 per item + Standard&nbsp;Rate</td>
                    </tr>
                    <tr>
                        <td>Canada<br />(5&nbsp;business&nbsp;days)</td>
                        <td>$17.99 per item + Standard&nbsp;Rate</td>
                    </tr>
                    <tr>
                        <td>APO/FPO <br />(12&nbsp;days)</td>
                        <td>No additional charges</td>
                    </tr>
                    <tr>
                        <td>US Territories (7&nbsp;business&nbsp;days)</td>
                        <td>$9.99 per item + Standard&nbsp;Rate</td>
                    </tr>
                    <tr>
                        <td>International (10&nbsp;business&nbsp;days)</td>
                        <td>$29.99 per item + Standard&nbsp;Rate</td>
                    </tr>
                </tbody>
            </table>

        </div>

        <p><b>Celebrations Passport Shipping</b></p>
        <ul>
            <li>Free standard shipping</li>
            <li>Free 2-day or 3-day shipping</li>
            <li>Standard overnight for $3.99 (instead of $19.99)</li>
            <li>Priority Overnight (Saturday delivery) for $12.99 (instead of $24.99)</li>
            <li>No surcharge $5.99 surcharge for PO Boxes</li>
            <li>No $9.99 surcharge for Alaska or Hawaii addresses</li>
        </ul>

        <p><b>Celebrations Passport Exclusions:</b></p>
        <ul>
            <li>Gifts containing wine</li>
            <li>Non-Fruit club gifts</li>
        </ul>
        <p><b>Note: Although not valid on wine gifts, Wine add-ons are eligible for Celebrations Passport</b></p>

        <div className="clear" />
    </div>

);

ShippingInfo.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(ShippingInfo);
